import { jsx as e, jsxs as m } from "react/jsx-runtime";
import "react";
import "dayjs";
import "react-i18next";
import "../../../contexts/global-context.js";
import "motion/react";
import { PrimaryButtonLink as n, SecondaryButtonLink as N } from "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import { Heading as h } from "../../elements/heading/heading.js";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import v from "./components/hero-cta-shape/hero-cta-shape.js";
import a from "./hero-cta-block.module.less.js";
const C = ({
  theme: i,
  eyebrow: s,
  title: t,
  text: o,
  buttonLink: r,
  imageDesktop: p,
  imageMobile: c,
  index: l
}) => {
  const d = typeof l == "number" && l > 0;
  return /* @__PURE__ */ e("section", { className: "max-width padded-sides centered space-mb-2xl", children: /* @__PURE__ */ m("div", { className: `${a.innerWrapper} theme-${i}`, children: [
    /* @__PURE__ */ m("div", { className: a.eyebrowTitleWrapper, children: [
      s && /* @__PURE__ */ e("p", { className: "eyebrow", children: s }),
      /* @__PURE__ */ e(h, { className: a.title, visualType: "h1", semanticType: d ? "h2" : "h1", children: t })
    ] }),
    /* @__PURE__ */ m("div", { className: a.textAndButtonWrapper, children: [
      o && /* @__PURE__ */ e("p", { className: "my-0 body-l", children: o }),
      i === "green" && /* @__PURE__ */ e(
        n,
        {
          className: "mt-md",
          url: r?.url,
          label: r?.title,
          onPreNavigate: r?.onPreNavigate
        }
      ),
      i === "orange" && /* @__PURE__ */ e(
        N,
        {
          className: "mt-md",
          url: r?.url,
          label: r?.title,
          onPreNavigate: r?.onPreNavigate
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: a.shapeWrapper, children: /* @__PURE__ */ e(v, { blockIndex: l, imageDesktop: p, imageMobile: c }) })
  ] }) });
};
export {
  C as HeroCTABlock,
  C as default
};
